@if (jobListData.length > 0) {
<div class="job-list-container" [ngClass]="{'job-list-container-with-alert': !isCareerGoalSet, 'job-list-container-with-filter': isFilterTabOpen}">
  <div *ngFor="let job of jobListData; let i= index">

    <div class="job-list-item"
      [class]="currentJobIndex == i ? 'active-job-item' : ''"
      (click)="onClickJobItem(i)"
      tabindex="0"
      role="option"
      [attr.aria-selected]="currentJobIndex == i"
      [attr.aria-label]="job.job_title + ' at ' + job.employer_name"
      (keydown)="onKeydown($event, i)"
      (focus)="onFocusJobItem(i)"
      #jobItem>

      <!-- Left section: Job details -->
      <div class="job-details">
        <div class="left-badge">
          @if(!job.is_active) {
            <img class="inactive-job-icon"  src="/assets/images/calendar-xmark.png" alt="inactive-job-category" />
          } @else {
            <img  src="{{ getMatchIndicatorIcon(job.score_category) }}" alt="score-match-category" />
          }
        </div>

        <div>
          <h2 class="job-title">{{ job.job_title }}</h2>
          <p class="job-company">{{ job.employer_name }}</p>

          <!-- Bottom row with icons -->
          <div class="job-meta">
            @if (job.employment_type || job.is_internship) {
              <div class="meta-item">
                <img src="/assets/icons/find-job/role-suitcase.svg" alt="role" />
                <p>{{ job.is_internship ? 'Internship' : job.employment_type | underscoreToLower }}</p>
              </div>
            }
            @if (job.employment_location_type) {
              <div class="meta-item">
                <img src="/assets/icons/find-job/location-map.svg" alt="location" />
                @if(job.employment_location_type.toUpperCase() === 'REMOTE') {
                  <p>{{ job.location && job.location !== 'N/A' ? 'Remote-' + job.location : 'Remote' }}</p>
                } @else {
                  <p>{{ job.location }}</p>
                }
              </div>
            }
            @if (job.posting_date) {
              <div class="meta-item">
                <img src="/assets/icons/find-job/clock-time.svg" alt="time" />
                @if (job.is_active) {
                  <p>{{ job.posting_date | timeAgo }}</p>
                } @else {
                  <p>No longer available</p>
                }
               
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Right section: Badges -->
  <div class="job-badges">
    <div class="">
      @if(job.is_bookmarked) {
      <div class="bookmark-div" [class.disabled]="isBookmarkDisabled(job.posting_id)" (click)="onClickJobBookmark(job.posting_id, 'REMOVE'); $event.stopPropagation()">
        <img matTooltip="Unbookmark" matTooltipPosition="above" src="/assets/icons/bookmarked.svg"
          alt="bookmarked-icon" />
      </div>
      } @else {
      <div class="bookmark-div bookmark-hover" [class.disabled]="isBookmarkDisabled(job.posting_id)" (click)="onClickJobBookmark(job.posting_id, 'ADD'); $event.stopPropagation()">
        <img matTooltip="Bookmark" matTooltipPosition="above" src="/assets/icons/bookmark.svg" alt="bookmark-icon" />
      </div>
      }
    </div>
    <!-- <div *ngIf="!job.related_to_career_goal" class="margin-bottom match-indicator-yellow"></div> -->
  </div>

    </div>
  </div>

    @if (jobListData.length > 0) {
    <div class="view-more-div">
      @if (hasMoreItems) {
        <button 
          mat-flat-button 
          type="button" 
          class="view-more-btn"
          (click)="loadMore()"
        >
          VIEW MORE
          <img src="/assets/icons/results/down-arrow-teal.svg" class="arrow-class" />
        </button>
      } @else {
        <p class="no-more-data">You've reached the end</p>
      }
    </div>
  }
</div>

} @else {
<p class="no-jobs-text">No jobs found matching your criteria.</p>
}
